// extracted by mini-css-extract-plugin
export default {"container":"for_2kbKL"};